import { get, post } from '@/api/request';

const URI = "/role"

// 角色管理-角色列表
export const listRole = (page, size, params) => post(`${URI}/list?page=${page}&size=${size}`, params);
// 角色管理-角色选择
export const selectRole = params => get(`${URI}/select`, params);
// 角色管理-保存修改角色
export const saveOrUpdateRole = params => post(`${URI}/saveOrUpdate`, params);
// 角色管理-获取角色信息
export const getRole = id => get(`${URI}/info/${id}`);
// 角色管理-删除角色
export const delRole = id => get(`${URI}/delete/${id}`);
// 角色管理-授权角色
export const authRole = (roleId, params) => post(`${URI}/authorization/${roleId}`, params);


// WEBPACK FOOTER //
// ./src/api/system/role.js